module.exports = __webpack_public_path__ + "static/media/traction.834efc26.png";